import sprintf from './sprintf';
import { Translations, TranslateFunc } from './types';

export default function createTranslateFunction(
  messages: Translations,
): TranslateFunc {
  // tslint:disable-next-line no-any
  return (key = '', ...rest: any[]) => sprintf(messages[key] || key, ...rest);
}
